// src/utils/linkify.js
import React from "react";

const URL_REGEX = /(https?:\/\/[^\s<>"')\]]+)/g;

// Splits text so URLs render as clickable <a> tags.
// Trailing punctuation (e.g. "Visit https://x.com.") stays outside the link.
export const linkify = (text) => {
  if (!text) return null;

  return text.split(URL_REGEX).map((part, i) => {
    if (!/^https?:\/\//.test(part)) return part;

    const trailing = part.match(/[.,;:!?]+$/)?.[0] ?? "";
    const url = trailing ? part.slice(0, -trailing.length) : part;

    return (
      <React.Fragment key={i}>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {url}
        </a>
        {trailing}
      </React.Fragment>
    );
  });
};
